import { FC } from "react";
import { AgVideoWidgetProps } from "./AgVideoWidget.interface";

const AgVideoWidget: FC<AgVideoWidgetProps> = ({ partnerId, className }) => (
  <agbm-video-widget class={className} partner-id={partnerId} />
);

export default AgVideoWidget;
